import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { NgSelectConfig } from '@ng-select/ng-select';
import { filter, map, takeUntil } from 'rxjs/operators';
import { ModalService } from '@core/services/modal.service';
import { NbIconLibraries } from '@nebular/theme';
import { Subject } from 'rxjs';
import { StateService } from '@core/services/state.service';

@Component({
	selector: 'ngx-app',
	template: `<router-outlet></router-outlet>`,
	imports: [RouterOutlet]
})
export class AppComponent implements OnInit, OnDestroy {
	private readonly unsubscribe$ = new Subject<void>();

	constructor(
		private router: Router,
		private modal: ModalService,
		private ngSelect: NgSelectConfig,
		private iconLibraries: NbIconLibraries,
		private stateService: StateService
	) {
		this.ngSelect.openOnEnter = false;
		this.ngSelect.appendTo = 'body';

		this.iconLibraries.registerFontPack('energi', { iconClassPrefix: 'energi' });
		this.iconLibraries.setDefaultPack('energi');
	}

	async ngOnInit() {
		// Modals belong to the page they were opened on, so they close when the path changes. A change to the query
		// string alone keeps them: pages write their state there (core/url-state), often as a modal opens.
		let path = pathOf(this.router.url);
		this.router.events
			.pipe(
				filter(event => event instanceof NavigationEnd),
				map(event => pathOf(event.urlAfterRedirects)),
				filter(next => {
					const changed = next !== path;
					path = next;
					return changed;
				}),
				takeUntil(this.unsubscribe$)
			)
			.subscribe(() => this.modal.closeAll('routeChange'));

		this.stateService.zenMode$.pipe(takeUntil(this.unsubscribe$)).subscribe(active => {
			document.body.classList.toggle('zen-mode-active', active);
		});
	}

	ngOnDestroy(): void {
		this.unsubscribe$.next(undefined);
		this.unsubscribe$.complete();
	}
}

/** The URL without its query string and fragment. */
export function pathOf(url: string): string {
	return url.split(/[?#]/)[0];
}
